import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { NavLink, withRouter } from 'react-router-dom';

class Sidebar extends PureComponent {
  static propTypes = {
    permissions: PropTypes.arrayOf(PropTypes.string),
  };

  render() {
    const { permissions = [] } = this.props;
    return (
      <aside className="main-sidebar sidebar-dark-primary elevation-4">
        <NavLink className="brand-link" to={`${this.props.match?.path}/sale`}>
          <span className="brand-text font-weight-light">
            {this.props.authOfficeName || 'Home'}
          </span>
        </NavLink>
        <div className="sidebar">
          <nav className="mt-2">
            <ul
              className="nav nav-pills nav-sidebar flex-column"
              data-accordion="false"
              data-widget="treeview"
              role="menu"
            >
              {permissions?.includes?.('color.index') && (
                <li className="nav-item">
                  <NavLink
                    className="nav-link"
                    to={`${this.props.match?.path}/color`}
                  >
                    <i className="fas fa-palette nav-icon"></i>
                    Color
                  </NavLink>
                </li>
              )}
              {permissions?.includes?.('customer.index') && (
                <li className="nav-item">
                  <NavLink
                    className="nav-link"
                    to={`${this.props.match?.path}/customer`}
                  >
                    <i className="fas fa-users nav-icon"></i>
                    Customer
                  </NavLink>
                </li>
              )}
              {permissions?.includes?.('installment.index') && (
                <li className="nav-item">
                  <NavLink
                    className="nav-link"
                    to={`${this.props.match?.path}/installment`}
                  >
                    <i className="fas fa-grip-lines nav-icon"></i>
                    Installment
                  </NavLink>
                </li>
              )}
              {permissions?.includes?.('office.index') && (
                <li className="nav-item">
                  <NavLink
                    className="nav-link"
                    to={`${this.props.match?.path}/office`}
                  >
                    <i className="fas fa-warehouse nav-icon"></i>
                    Office
                  </NavLink>
                </li>
              )}
              {permissions?.includes?.('purchase.index') && (
                <li className="nav-item">
                  <NavLink
                    className="nav-link"
                    to={`${this.props.match?.path}/purchase`}
                  >
                    <i className="fas fa-store nav-icon"></i>
                    Purchase
                  </NavLink>
                </li>
              )}
              {permissions?.some?.(p => [
                'report.sale',
                'report.sale_data',
                'report.stock',
              ]?.includes?.(p)) && (
                <li className="nav-item menu-open">
                  <NavLink
                    className="nav-link"
                    to={`${this.props.match?.path}/report`}
                  >
                    <i className="fas fa-chart-bar nav-icon"></i>
                    <p>
                      Report
                      <i className="fas fa-angle-left right"></i>
                    </p>
                  </NavLink>
                  <ul className="nav nav-treeview">
                    {permissions?.includes?.('report.sale') && (
                      <li className="nav-item">
                        <NavLink
                          className="nav-link"
                          to={`${this.props.match?.path}/report/sale`}
                        >
                          <i className="fas fa-shopping-cart nav-icon"></i>
                          Sale
                        </NavLink>
                      </li>
                    )}
                    {permissions?.includes?.('report.sale_data') && (
                      <li className="nav-item">
                        <NavLink
                          className="nav-link"
                          to={`${this.props.match?.path}/report/sale-data`}
                        >
                          <i className="fas fa-shopping-cart nav-icon"></i>
                          Sale Data
                        </NavLink>
                      </li>
                    )}
                    {permissions?.includes?.('report.stock') && (
                      <li className="nav-item">
                        <NavLink
                          className="nav-link"
                          to={`${this.props.match?.path}/report/stock`}
                        >
                          <i className="fas fa-cubes nav-icon"></i>
                          Stock
                        </NavLink>
                      </li>
                    )}
                  </ul>
                </li>
              )}
              {permissions?.includes?.('role.index') && (
                <li className="nav-item">
                  <NavLink
                    className="nav-link"
                    to={`${this.props.match?.path}/role`}
                  >
                    <i className="fas fa-user-tag nav-icon"></i>
                    Role
                  </NavLink>
                </li>
              )}
              {permissions?.includes?.('sale.index') && (
                <li className="nav-item">
                  <NavLink
                    className="nav-link"
                    to={`${this.props.match?.path}/sale`}
                  >
                    <i className="fas fa-shopping-cart nav-icon"></i>
                    Sale
                  </NavLink>
                </li>
              )}
              {permissions?.includes?.('stock.index') && (
                <li className="nav-item">
                  <NavLink
                    className="nav-link"
                    to={`${this.props.match?.path}/stock`}
                  >
                    <i className="fas fa-cubes nav-icon"></i>
                    Stock
                  </NavLink>
                </li>
              )}
              {permissions?.includes?.('user.index') && (
                <li className="nav-item">
                  <NavLink
                    className="nav-link"
                    to={`${this.props.match?.path}/user`}
                  >
                    <i className="fas fa-users-cog nav-icon"></i>
                    User
                  </NavLink>
                </li>
              )}
              {permissions?.includes?.('vehicle.index') && (
                <li className="nav-item">
                  <NavLink
                    className="nav-link"
                    to={`${this.props.match?.path}/vehicle`}
                  >
                    <i className="fas fa-motorcycle nav-icon"></i>
                    Vehicle
                  </NavLink>
                </li>
              )}
            </ul>
          </nav>
        </div>
      </aside>
    );
  }
}

const mapStateToProps = state => ({
  authOfficeName: state?.auth?.office?.name,
  permissions: state?.auth?.permissions,
});

export default withRouter(connect(mapStateToProps)(Sidebar));
